import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-debt-details-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './company-debt-details-dialog.component.html',
    styleUrl: './company-debt-details-dialog.component.scss'
})
export class CompanyDebtDetailsDialogComponent {
    @Input() debt: any;

    constructor(public activeModal: NgbActiveModal) {
    }

    getTotalCharges(debt: any): number {
        const interest = debt.interestValue || 0;
        const fine = debt.fineValue || 0;
        const charges = debt.chargesValue || 0;
        return interest + fine + charges;
    }

    getStatusBadgeClass(status: string): string {
        const statusMap: { [key: string]: string } = {
            'DEFERIDO E CONSOLIDADO': 'badge bg-dark text-white',
            'AGUARDANDO DEFERIMENTO': 'badge bg-light text-dark border',
            'EM ANÁLISE': 'badge bg-light text-dark border',
            'PENDENTE': 'badge bg-light text-dark border'
        };
        return statusMap[status] || 'badge bg-light text-dark border';
    }

    onAssumeLead(): void {
        this.activeModal.close({action: 'assume', debt: this.debt});
    }
}

